import { render } from "./detail.vue?vue&type=template&id=cd2ed4b6&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=cd2ed4b6&lang=scss&scoped=true"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd2ed4b6"]])

export default __exports__